import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CART_VOUCHER_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { CartVoucherBlockScenarioContent } from '@front-platform/content-builder';
import {
  CART_VOUCHER_BLOCK_LOADING_VM,
  CartVoucherBlockDataSource,
  CartVoucherBlockViewModel,
} from './cart-voucher-block-view-model';

function toCartVoucherPreviewViewModel(
  content: CartVoucherBlockScenarioContent,
): CartVoucherBlockViewModel {
  return {
    isVisible: content.isVisible,
  };
}

@Injectable()
export class CartVoucherBlockPreviewDataSource implements CartVoucherBlockDataSource {
  readonly vm$: Observable<CartVoucherBlockViewModel> = previewScenarioForBloc$(
    CART_VOUCHER_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CART_VOUCHER_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<CartVoucherBlockScenarioContent>(
        scenario,
        CART_VOUCHER_BLOCK_COMPONENT,
      );
      return content ? toCartVoucherPreviewViewModel(content) : CART_VOUCHER_BLOCK_LOADING_VM;
    }),
  );
}
